import { useEffect, useState } from "react";

// Static site content lives in public/data/*.json so it can be edited on the
// server (e.g. via FTP) without rebuilding the app.
const cache = {};

const loadContent = (name) => {
  if (!cache[name]) {
    cache[name] = fetch(`${process.env.PUBLIC_URL}/data/${name}.json`, {
      cache: "no-cache",
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .catch((err) => {
        console.error(`Failed to load ${name}.json:`, err);
        delete cache[name];
        return {};
      });
  }
  return cache[name];
};

const useSiteContent = (name) => {
  const [content, setContent] = useState({});

  useEffect(() => {
    let active = true;
    loadContent(name).then((data) => {
      if (active) setContent(data);
    });
    return () => {
      active = false;
    };
  }, [name]);

  return content;
};

export default useSiteContent;
